import { classNames } from "lib/utils";
import { memo } from "react";
import { MODEL_PROVIDERS, ModelProvider } from "@/services/promptEditor.service";

const UnmemoizedProviderLogo = ({ name, className }: { name: ModelProvider; className: string }) => {
  switch (name) {
    case MODEL_PROVIDERS.openai:
      return <img src="/assets/providers/openai-logomark.svg" alt={name} className={className} />;
    case MODEL_PROVIDERS.anthropic:
      return <img src="/assets/providers/anthropic-logomark.svg" alt={name} className={className} />;
    case MODEL_PROVIDERS.deepmind:
      return <img src="/assets/providers/deepmind-logomark.svg" alt={name} className={className} />;
    case MODEL_PROVIDERS.cohere:
      return <img src="/assets/providers/cohere-logomark-new.svg" alt={name} className={className} />;
    case MODEL_PROVIDERS.openai_azure:
      return <img src="/assets/providers/azure-logomark.svg" alt={name} className={className} />;
    case MODEL_PROVIDERS.replicate:
      return <img src="/assets/providers/replicate-logomark.svg" alt={name} className={className} />;
    case MODEL_PROVIDERS.huggingface:
      return (
        <img
          src="/assets/providers/huggingface-logomark.svg"
          alt={name}
          className={classNames("scale-110 grayscale", className)}
        />
      );
    case MODEL_PROVIDERS.google:
      return <img src="/assets/providers/google-mark.svg" alt={name} className={className} />;
    case MODEL_PROVIDERS.bedrock:
      return <img src="/assets/providers/aws.svg" alt={name} className={classNames("scale-150", className)} />;

    case MODEL_PROVIDERS.groq:
      return <img src="/assets/providers/groq.svg" alt={name} className={className} />;
    case MODEL_PROVIDERS.deepseek:
      return <img src="/assets/providers/deepseek.svg" alt={name} className={className} />;
    default:
      return <div className="max-w-[40px] truncate font-bold">{name}</div>;
  }
};

export const ProviderLogo = memo(UnmemoizedProviderLogo);
